import React from 'react';
import {
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Tooltip,
  Box,
} from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'out_of_stock', label: 'Out of Stock' },
];

const PricingAndOthers = ({ form, update }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Pricing & Others
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField
            id="purchase-price"
            label="Purchase Price (₹)*"
            type="number"
            variant="outlined"
            fullWidth
            value={form.purchasePrice}
            onChange={(e) => update('purchasePrice', e.target.value)}
          />
          <Tooltip title="Purchase price">
            <IconButton>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="selling-price"
            label="Selling Price (₹)*"
            type="number"
            variant="outlined"
            fullWidth
            value={form.sellingPrice}
            onChange={(e) => update('sellingPrice', e.target.value)}
          />
          <Tooltip title="Selling price (must be ≥ purchase price)">
            <IconButton>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="minimum-stock-qty"
            label="Minimum Stock Qty"
            type="number"
            variant="outlined"
            fullWidth
            value={form.minStock}
            onChange={(e) => update('minStock', e.target.value)}
          />
          <Tooltip title="Minimum Stock Qty (low-stock threshold)">
            <IconButton>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="current-stock-qty"
            label="Current Stock Qty*"
            type="number"
            variant="outlined"
            fullWidth
            value={form.stock}
            onChange={(e) => update('stock', e.target.value)}
          />
          <Tooltip title="Current Stock Qty">
            <IconButton>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="tax-amount"
            label="Tax Amount (%)"
            type="number"
            variant="outlined"
            fullWidth
            value={form.tax}
            onChange={(e) => update('tax', e.target.value)}
          />
          <Tooltip title="Tax Amount (%)">
            <IconButton>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <InputLabel id="status-select-label">Status</InputLabel>
            <Select
              labelId="status-select-label"
              id="status-select"
              label="Status"
              value={form.status}
              onChange={(e) => update('status', e.target.value)}
            >
              {STATUS_OPTIONS.map((s) => (
                <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PricingAndOthers;
